export const roomTypes = {
  SINGLE: "Sencilla",
  DOUBLE: "Doble",
  TRIPLE: "Triple",
  JRSUITE: "Jr Suite",
  SUITE: "Suite",
};